// extracted by mini-css-extract-plugin
export default {"container":"AdminsTable_container__65zvi","create":"AdminsTable_create__X1U5H","icon":"AdminsTable_icon__qgNvb"};